/*
 * This file provides types for the sort options available for certain parts of the dashboard.
 * It does not provide any actual information about those options.
 *
 * For how these options should be displayed in the UI, that's for the view
 * layer to handle. Each page can map these provided options to the visual data
 * needed for displaying them.
 *
 * For how these options map to any additional data needed for performing the actual
 * sorting, right now thats handled by the classicSortOptions file in the @trello/enterprise
 * package. That file provides mappings from the options given here, to the data needed
 * by the classic ItemLists models to perform sorting.
 */
export enum PendingTeamsSortOption {
  AZ = 'A-Z',
  ZA = 'Z-A',
  LeastRecentlyCreated = 'least-recently-created',
  MostRecentlyCreated = 'most-recently-created',
}
